"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DOMAIN = exports.VERSION = void 0;
exports.VERSION = '9.2.1';
const versionN = exports.VERSION.split('.').map(s => parseInt(s, 10));
exports.DEFAULT_DOMAIN = `https://connect.trezor.io/${versionN[0]}/`;
//# sourceMappingURL=version.js.map